import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Sociedad } from '../models/sociedad';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Sociedades';

@Injectable({
  providedIn: 'root'
})
export class SociedadService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(sociedad: Sociedad)
  {
    return this._http.post({ url: baseUrl + '/Save', body: sociedad });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

}

